import { installIcon } from "assets/images";
import { useBrandsConfig } from "utils/v2/BrandsConfig/BrandsConfigContext";

const CustomInstallModal = () => {
  const { title } = useBrandsConfig();
  const closeModal = () => {
    let el = document.getElementById("customInstallModal");
    if (el?.style) el.style.display = "none";
  };

  return (
    <div onClick={closeModal} className="pwaInstallBg" id="customInstallModal">
      <div
        onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
          e.stopPropagation()
        }
        className="pwaInstallContainer"
      >
        <div className="pwaInstallTitle">نصب اپلیکیشن</div>
        <div className="pwaInstallContent">
          <img className="pwaInstallImg" alt="install" src={installIcon} />
          <div className="pwaInstallTxt">
            <div className="pwaInstallTxtTitle">{title} GPS</div>
            <div>آیا می خواهید این اپلیکیشن را نصب کنید؟</div>
          </div>
        </div>

        <div className="pwaInstallButtonsContainer">
          <div
            onClick={closeModal}
            className="pwaInstallButton pointer"
            id="installApp"
          >
            نصب
          </div>
          <div onClick={closeModal} className="pwaInstallButtonCancel pointer">
            انصراف
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomInstallModal;
